<template>
    <div >
        <div v-show="this.oncharge==false" >
            <StatMemberMonth ref="statTransfMonth"  v-bind:datee="select_date" @updateCharge="updateCharge" ></StatMemberMonth>
            <StatMemberYear ref="statTransfYear"  v-bind:datee="select_date" ></StatMemberYear>
        </div>
        <div v-show="this.oncharge">
            <vx-card>
                <wait/>
            </vx-card>
        </div >
    </div>
</template>

<script>
import StatMemberMonth from '@/components/stats/components/graphAccueil/statTransfMonth.vue'
import StatMemberYear from '@/components/stats/components/graphAccueil/statTransfYear.vue'

import wait from '@/components/stats/components/graphAccueil/waiting.vue'


export default {
    components:{
        StatMemberMonth,
        StatMemberYear,
        wait
    },
    data(){
        return{
            oncharge:false,
            select_date:new Date(),
            motifsList:[]
        }
    },
    watch:{
            oncharge:function(){
                // console.log("this. ", this.oncharge)
            }
    },
    mounted() {
        this.UpdateTaux()
    },
    methods:{
         UpdateStatTransformationMonth(select_date){
             this.select_date=select_date
            this.$refs.statTransfMonth.setDate( this.select_date)
            this.$refs.statTransfYear.setDate( this.select_date)
        },

        UpdateTaux(date){
            this.select_date=date;
            this.$refs.statTransfMonth.refresh()
            this.$refs.statTransfYear.refresh()
        },

        updateCharge(val){
           
            this.oncharge=val;
        },
        
        
        
    }
}
</script>

<style>

</style>